import React, { useState, useEffect, useContext } from 'react';

import Grid from '@mui/material/Grid';

import ErrorMessage from '../../../sharedModules/layout/ErrorMessage';
import ListPage from '../../../sharedModules/listPage/ListPage';
import LoadingWrapper from '../../../sharedModules/layout/LoadingWrapper';

import { SelectOption } from '../../../sharedModules/form/model';

import axios from '../../../sharedModules/utils/axios.utils';
import { useLocation } from '../../contexts/LocationContext';
import { AuthenticationContext } from '../../../homeModules/auth/contexts/AuthenticationContext';

const ChillerApprovalsListPage: React.FC = () => {
  const { selectedLocation } = useLocation();
  const { user } = useContext(AuthenticationContext);
  const [customerOptions, setCustomerOptions] = useState<SelectOption[]>();
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [teamOptions, setTeamOptions] = useState<SelectOption[]>();
  const [userOptions, setUserOptions] = useState<SelectOption[]>();

  const fetchChillerFilterOptions = async () => {
    setLoading(true);
    try {
      const response: any = await axios.get('/chiller_logs/chiller_logs/new');
      setCustomerOptions(response.data.client_options);
      setUserOptions(response.data.user_options);
      setTeamOptions(response.data.team_options);
      setErrorMessage('');
    } catch (error) {
      setErrorMessage('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchChillerFilterOptions();
  }, []);

  const chillerApprovalFilters = [
    {
      label: 'Customer',
      type: 'select',
      choices: customerOptions,
      param: 'chiller_jobs_company_name_eq',
    },
    {
      label: 'Logging Tech',
      type: 'select',
      choices: userOptions,
      param: 'emp_id_eq',
      mutuallyExclusiveWith: ['team_id_eq'],
    },
    {
      label: 'Team',
      type: 'select',
      choices: teamOptions,
      param: 'team_id_eq',
      mutuallyExclusiveWith: ['emp_id_eq'],
    },
    {
      label: 'Submitted',
      type: 'datePicker',
      param: 'submit_dt',
      width: 5,
    },
  ];

  const chillerApprovalColumns = [
    {
      name: 'Submitted',
      selector: 'submit_dt',
      sortable: true,
    },
    {
      name: 'Order',
      selector: 'order_no',
      sortable: true,
    },
    {
      name: 'Customer',
      selector: 'company_name',
      grow: 2,
      sortable: true,
    },
    {
      name: 'Address',
      selector: 'address',
      grow: 2,
      sortable: true,
    },
    {
      name: 'Asset',
      selector: 'chlr_no',
      sortable: true,
    },
    {
      name: 'Department',
      selector: 'dept_name',
      sortable: true,
    },
    {
      name: 'Logging Tech',
      selector: 'display_emp_id',
      sortable: true,
    },
  ];

  const ledTeamFilter = user?.led_team || 'all';
  const defaultFilterSetting = { status_eq: 'pending_approval', team_id_eq: ledTeamFilter };
  const clearFilterSetting = { status_eq: 'pending_approval', team_id_eq: '', emp_id_eq: '' };

  return (
    <Grid container>
      <Grid item xs={12}>
        <LoadingWrapper isLoading={loading} message="Loading Filter Options">
          <Grid container>
            <Grid item xs={12}>
              <ErrorMessage message={errorMessage} />
            </Grid>
            <Grid item xs={12}>
              <ListPage
                clickableRows
                clearedFilterSetting={clearFilterSetting}
                columns={chillerApprovalColumns}
                controller="chiller_logs/chiller_logs"
                defaultFilters={defaultFilterSetting}
                filterDefinitions={chillerApprovalFilters}
                includeFilterBar
                queryPlaceholder="Order No"
                title="Chiller Jobs"
                subtitle="Approval Queue"
                additionalParams={{ location: selectedLocation }}
                rowClickQueryString="return_to=approvals"
              />
            </Grid>
          </Grid>
        </LoadingWrapper>
      </Grid>
    </Grid>
  );
};

export default ChillerApprovalsListPage;
